import React from "react"

import { libraryPostTypes } from "../../features/userGeneratedContent/lib/postTypes"

import AuthGuard from "../../features/ui/containers/AuthGuard"
import BookmarkedMaterials from "../../features/myLibrary/containers/BookmarkedMaterials"
import BackBar from "../../features/ui/components/Backbar"
import PageLayout from "../../layouts/PageLayout"

const BookmarkedPodcasts = BookmarkedMaterials(libraryPostTypes.podcasts)

const Podcasts = () => (
  <AuthGuard>
    <PageLayout
      bg="dark.7"
      banner={() => (
        <>
          <BackBar />
        </>
      )}
    >
      <BookmarkedPodcasts />
    </PageLayout>
  </AuthGuard>
)

export default Podcasts
